import React from 'react';

import useChainByCurrency from '@/hooks/useChainByCurrency';
import useTokenIconByCurrency from '@/hooks/useChainIconByCurrency';
import { cn } from '@/utils';

import { Currency } from '../../constants';

type TokenImgProps = {
  token: Currency;
  className?: string;
};

const TokenImg: React.FC<TokenImgProps> = ({ token, className }) => {
  const { chainData } = useChainByCurrency(token);
  const slug = token.split('_')[1];

  const { icon } = useTokenIconByCurrency(token);

  if (icon) {
    let chainIcon;

    if (slug) {
      if (icon && chainData?.custom && 'icon' in chainData.custom) {
        chainIcon = chainData.custom.icon as string;
      }
    }

    return (
      <div className={cn('relative aspect-square size-6', className)}>
        <img className="z-1 aspect-square size-full shrink-0 rounded-full" src={icon} alt={`${token} icon`} />
        {chainIcon && (
          <img
            className="bg-foreground absolute -right-[4px] -bottom-[4px] z-1 box-border size-[60%] rounded-full
              p-[0.5px]"
            src={chainIcon as string}
            alt={`${token} chain icon`}
          />
        )}
      </div>
    );
  }

  return <div className={cn('size-6', className)} />;
};

export default TokenImg;
